import React from 'react';

interface LineArrowRightIconProps {
  size?: number;
  color?: string;
}

export const LineArrowRightIcon: React.FC<LineArrowRightIconProps> = ({ size = 24, color = '#686868' }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 20L17 12L9 4" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
